'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiZoom = function TiZoom(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 6.7c-6.5 0-11.7 5.2-11.7 11.6 0 1.3 0.2 2.5 0.6 3.7l-2.1 2.1-1.7 1.7c-0.9 0.9-1.5 2.3-1.5 3.7 0 2.8 2.4 5.2 5.2 5.2 1.3 0 2.5-0.5 3.5-1.3l0.2-0.1 0.1-0.1 3.7-3.8c1.2 0.4 2.4 0.6 3.7 0.6 6.4 0 11.6-5.2 11.6-11.7s-5.2-11.6-11.6-11.6z m0 20c-4.6 0-8.4-3.8-8.4-8.4s3.8-8.3 8.4-8.3 8.3 3.7 8.3 8.3-3.7 8.4-8.3 8.4z m0-15c-3.7 0-6.7 3-6.7 6.6s3 6.7 6.7 6.7 6.6-3 6.6-6.7-3-6.6-6.6-6.6z m0 11.6c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.3 5 5-2.3 5-5 5z' })
        )
    );
};

exports.default = TiZoom;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/zoom.js
// module id = 3848
// module chunks = 0